import { useEffect } from "preact/hooks";
import { messageBus } from ".";
import { Action, ActionMap } from "./actions";
import { Message, MessageListener } from "./messageBus";

export function useMessageBus<K extends keyof ActionMap>(message: K, listener: ActionMap[K]): void;
export function useMessageBus<T extends Message>(message: string, listener: (message: T) => void): void;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useMessageBus(message: any, listener: any): void {
    useEffect(() => {
        return messageBus.subscribeEvery(message, listener as MessageListener);
    }, [message, listener]);
}

export function useMessageBusOne<K extends keyof ActionMap>(message: K, listener: ActionMap[K]): void;
export function useMessageBusOne<T extends Message>(message: string, listener: (message: T) => void): void;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useMessageBusOne(message: any, listener: any): void {
    useEffect(() => {
        return messageBus.subscribeOne(message, listener as MessageListener);
    }, [message, listener]);
}

export function useMessageBusAll(listener: (message: Action) => void): void;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useMessageBusAll(listener: any): void {
    useEffect(() => {
        return messageBus.subscribeAll(listener as MessageListener);
    }, [listener]);
}
